import { makeStyles } from '@material-ui/core/styles'
import { Toolbar } from '@mui/material'
import { SaveButton, Toolbar as RaToolbar } from 'react-admin'

import { useFlushActionsCacheMutation } from 'apollo/personalization/mutations/FlushActionsCache.generated'
import PresetExportButton from './PresetExportButton'

const styles = {
    toolbar: { margin: 0 }
}
const useStyles = makeStyles(styles)

const PresetManagerToolbar = (props) => {
    const classes = useStyles()
    const modelId = props?.record?.model?.id ?? ''
    const presetId = props?.record?.id as number
    const published = props?.record?.published

    const [flushActionsCache] = useFlushActionsCacheMutation()

    const handleSaveButtonClick = () => (props.isWithActionsFlush ? flushActionsCache() : undefined)

    return (
        <Toolbar sx={{ position: 'fixed', bottom: 0, margin: 0, zIndex: 2 }} disableGutters>
            <RaToolbar {...props} className={classes.toolbar}>
                <SaveButton onClick={handleSaveButtonClick} />
                {modelId ? (
                    <PresetExportButton
                        id={modelId}
                        presetId={presetId}
                        published={published}
                        isWithActionsFlush={props.isWithActionsFlush}
                    />
                ) : null}
            </RaToolbar>
        </Toolbar>
    )
}
export default PresetManagerToolbar
